import { useEffect, useState, useCallback } from 'react';
import APIManager from '../connection/ApiManager';

export function useFixedAttributeDisplayNames() {
  const [fixedAttributeDisplayNames, setFixedAttributeDisplayNames] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDisplayNames = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await APIManager.getInstance().getDynamicAttributes();
      const names = res?.data?.fixed_attribute_display_names || {};
      setFixedAttributeDisplayNames(names);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDisplayNames();
  }, []);
  return { fixedAttributeDisplayNames, refresh: fetchDisplayNames, loading, error };
}

export async function fetchFixedAttributeDisplayNames() {
  const res = await APIManager.getInstance().getDynamicAttributes();
  return res?.data?.fixed_attribute_display_names || {};
}
